/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Folder_HelpInputs */



/**
* | output |
* | --- |
* | "Select an export location for your video" |
*
* @param {Video_Export_Folder_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_folder_help = /** @type {((inputs?: Video_Export_Folder_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Folder_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionnez un emplacement d'exportation pour votre video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie einen Exportort für Ihr Video aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona una posizione di esportazione per il tuo video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите место экспорта для вашего видео.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione una ubicación de exportación para su vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择视频导出位置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオのエクスポート先を選択してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपने वीडियो के लिए निर्यात स्थान चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione um local para exportar seu vídeo.")
	return /** @type {LocalizedString} */ ("Select an export location for your video")
});